<script>
    import useLoadScript from "@songfinch/customer/composables/useLoadScript";
    export default {
        name: "GoogleReviews",
        props: {
            script: {
                type: String,
                default: ""
            },
            title: {
                type: String,
                default: ""
            },
            image: {
                type: Object,
                default: null
            }
        },
        setup() {
            useLoadScript("https://static.elfsight.com/platform/platform.js");
        },
    };
</script>
<template>
    <div class="@container">
        <h2 v-if="title" class="!@mb-14 tablet:!@mb-8 @text-center @max-w-700 @m-auto" v-text="title"/>
        <div v-if="image" class="@mb-8 tablet:@mb-10 @text-center">
            <img :src="$cld.url(image)" class="@inline-block" alt="icons">
        </div>
        <div class="GoogleReviews">
            <div v-if="script" v-html="script"/>

            <div v-else>
                <div id="GoogleReviews" ref="googleReviews" class="elfsight-app-4045de28-7051-4b4a-b3dc-b02932e18aed" data-elfsight-app-lazy/>
            </div>
        </div>
    </div>
</template>
